// extracted by mini-css-extract-plugin
module.exports = {"root":"az_qHb","positionFixed":"az_rHb","positionAbsolute":"az_sHb","positionSticky":"az_tHb","positionStatic":"az_uHb","positionRelative":"az_vHb"};